import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { LocalizacaoEstoqueService } from '../../../../shared/services/apis/produto/localizacao-estoque.service';
import { LocalizacaoEstoqueRequest } from '../../../../shared/services/requests/produto/localizacao-estoque.request';
import { HeaderComponent } from '../../../../shared/components/header/header.component';

@Component({
  selector: 'app-localizacao-estoque-cadastro',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    LoadingBoxComponent,
    FooterActionComponent,
    HeaderComponent,
  ],
  templateUrl: './localizacao-estoque-cadastro.component.html',
  styleUrl: './localizacao-estoque-cadastro.component.css',
})
export class LocalizacaoEstoqueCadastroComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Suprimentos;
  public form: FormGroup;
  public isLoading: boolean = false;
  public isSaving: boolean = false;
  public isEdicao: boolean = false;
  public isPadrao: boolean = false;
  public idLocalizacaoEstoque: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private localizacaoEstoqueService: LocalizacaoEstoqueService,
    private alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.route.params.subscribe(params => {
      if (params['idLocalizacaoEstoque']) {
        this.idLocalizacaoEstoque = +params['idLocalizacaoEstoque'];
        this.isEdicao = true;
        this.carregarLocalizacao();
      }
    });
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      codigo: ['', Validators.required],
      nome: ['', Validators.required],
      isAtivo: [true],
    });
  }

  private carregarLocalizacao(): void {
    this.isLoading = true;
    this.localizacaoEstoqueService.getById(this.idLocalizacaoEstoque).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription || 'Erro ao carregar localização.', AlertType.error);
          this.voltar();
          return;
        }
        const item = res.listaLocalizacaoEstoque && res.listaLocalizacaoEstoque.length > 0 ? res.listaLocalizacaoEstoque[0] : null;
        if (item) {
          this.isPadrao = item.isPadrao;
          this.form.patchValue({
            codigo: item.codigo,
            nome: item.nome,
            isAtivo: item.isAtivo,
          });
          // Localização padrão deve estar sempre ativa: não permitir alterar o status pela edição.
          if (item.isPadrao) {
            this.form.get('isAtivo')?.disable();
          }
        }
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Ocorreu um erro ao carregar a localização.', AlertType.error);
        this.voltar();
      },
    });
  }

  public salvar(): void {
    if (this.form.invalid) {
      this.alertService.show('Atenção', 'Preencha todos os campos obrigatórios.', AlertType.warning);
      return;
    }

    this.isSaving = true;
    // getRawValue inclui controles desabilitados (ex.: isAtivo quando é a localização padrão).
    const request: LocalizacaoEstoqueRequest = this.form.getRawValue();
    if (this.isEdicao) {
      this.localizacaoEstoqueService.update(this.idLocalizacaoEstoque, request).subscribe({
        next: res => this.tratarRetorno(res),
        error: err => this.tratarErro(err),
      });
    } else {
      this.localizacaoEstoqueService.create(request).subscribe({
        next: res => this.tratarRetorno(res),
        error: err => this.tratarErro(err),
      });
    }
  }

  private tratarRetorno(res: any): void {
    this.isSaving = false;
    if (res.isError) {
      this.alertService.show('Atenção', res.errorDescription || 'Erro ao salvar localização.', AlertType.warning);
    } else {
      this.alertService.show('Sucesso', 'Localização salva com sucesso.', AlertType.success);
      this.voltar();
    }
  }

  private tratarErro(_: any): void {
    this.isSaving = false;
    this.alertService.show('Erro', 'Ocorreu um erro ao salvar.', AlertType.error);
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/suprimentos/localizacao-estoque']);
  }
}
